import type { Editor } from '@tiptap/core';
import type { EditorExternalStores } from '../types/EditorExternalStores';

export const getExternalStore = <
  K extends keyof EditorExternalStores = keyof EditorExternalStores,
>(
  editor: Editor | null | undefined,
  key: K,
): EditorExternalStores[K] => {
  if (!editor) {
    throw new Error('Editor is not defined');
  }
  return editor.options.externalStores?.[key];
};
